{
  "version": 1,
  "asset_id": "12c48c98-5bec-438e-b498-13ec39729230",
  "project_id": "1820e758-46fa-46b0-bd5a-016534d0d263",
  "url": "/__l5e/assets-v1/12c48c98-5bec-438e-b498-13ec39729230/wordmark-1200.png",
  "r2_key": "a/v1/1820e758-46fa-46b0-bd5a-016534d0d263/12c48c98-5bec-438e-b498-13ec39729230/wordmark-1200.png",
  "original_filename": "wordmark-1200.png",
  "size": 110637,
  "content_type": "image/png",
  "created_at": "2026-07-25T02:18:51Z"
}
